<template>
  <svg width="24" height="18" viewBox="0 0 24 18" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#ADADAD" fill="none" fill-rule="evenodd">
      <path
        d="M10.865 5.591h10.67a1.196 1.196 0 110 2.392h-10.67M4.826 5.591H2.36C1.61 5.591 1 6.127 1 6.787c0 .66.609 1.196 1.36 1.196h2.466M21.583 9.51v1.533a4.783 4.783 0 01-4.783 4.783H7.235a4.783 4.783 0 01-4.783-4.783V9.51M21.2 5.591V2.435C21.2 1.642 20.558 1 19.765 1c-.686 0-1.243.557-1.243 1.243v.808h0"
      />
      <path stroke-linecap="round" d="M3.887 17.261l.957-1.913M20.148 17.261l-.957-1.913" />
      <path
        d="M7.278 4.826h2.305a1 1 0 011 1v5.304a.2.2 0 01-.2.2H6.478a.2.2 0 01-.2-.2V5.826a1 1 0 011-1z"
      />
      <path stroke-linecap="square" d="M6.757 9.13h3.826" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconBaths',
};
</script>

<style></style>
